import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'truncate',
})
export class TruncatePipe implements PipeTransform {
    transform(value: any, args: any): any {
        const length = args.length;
        if (value && value.length > length) {
            return value.substring(0, length) + (args.suffix || '...');
        }
        return value;
    }
}
